import React,{useEffect,useState} from 'react'
import {auth} from '../firebase'
const Admin = () => {
    
    const[usuario,setUsuario]=useState(null)
    useEffect(() => {
        auth.onAuthStateChanged((user)=>{
            if(user){
                setUsuario(user.email)
            }
        })    
    }, [])

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-8 mx-auto">
                <h2 className="text-center mt-5 col-md-6">Bienvenido:</h2>
                <h4 className="text-center">{usuario}</h4>
                </div>
            </div>
            
        </div>
    )
}

export default Admin
